import React from 'react';

import cx from 'classnames';
import styles from './styles.module.scss';

import { Image } from 'react-bootstrap';

import IntegrationsService from 'src/legacy/services/integrations.service';

import IntegrationConfirmView from './IntegrationConfirmView'
import SlidePaneView from 'src/legacy/components/SlidePaneView';

import buildUrl from "build-url-ts";
import { shouldFetchIntegrations } from 'src/legacy/services/utils';
import _ from 'lodash';
import { localizedStrings } from 'src/localization/index.jsx';
import CardView from 'src/legacy/components/Card';

class IntegrationsView extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      showIntegrationConfirmView : false,
      activatedIntegration: null,
      clickedIntegration: null,
      integrationsMasterList: this.getIntegrations(),
      filter: 'ALL'
    }

    this.handleCardClick = this.handleCardClick.bind(this);
    this._handleFilterClicked = this._handleFilterClicked.bind(this);
    this._handleURLUpdate = this._handleURLUpdate.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedIntegrations = localizedStrings.components.integrations;
  }

  componentDidMount() {
    if (shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
    this.props.fetchActivatedWorkspaces();
    // this._handleURLUpdate(_.get(this.props.location.query, "type" , "ALL"));
  }

  getIntegrations(){
    const integrationsList = IntegrationsService.getIntegrations(localizedStrings.components.integrations.integrations);
    return integrationsList.integrations;
  }

  getIntegrationsV2(){
    const integrationsList = IntegrationsService.getIntegrations(localizedStrings.components.integrations.integrations);
    return integrationsList.integrationsV2;
  }

  handleCardClick(integration, activated){
     
    this.props.trackAdoptionMetricsForIntegrationPartnerSelectedEvent(integration.name);
    let existingIntegration = this.getIntegrationForCategory(integration.category);
    if((existingIntegration != null && !activated && integration.category !== 'CRM')) {
        this.setState({
          showIntegrationConfirmView : true,
          activatedIntegration: existingIntegration,
          clickedIntegration: integration
        })
    }else{
      this.props.navigate(integration.route);
    }
  }

  _updateUrl(filter){
    const url = buildUrl(`/settings/integrations`, {
      queryParams: {
        type: filter,
      },
    });
    // browserHistory.replace(url);
  }

  _handleURLUpdate(type) {
    this._handleFilterClicked(type)
  }

  _handleFilterClicked(filter) {
      if (!filter) {
        filter = "all"
      }     
    const requestedFilter = filter.toUpperCase();
    const filterType = (requestedFilter == "MARKETING_AUTOMATION") ? "Marketing Automation" : (requestedFilter == "CRM") ? requestedFilter: _.capitalize(requestedFilter);
    this.props.trackAdoptionMetricsForIntegrationsFilteredEvent(filterType);

      if(requestedFilter === 'ALL'){
        this.setState({
          integrationsMasterList: this.getIntegrations(),
          filter: requestedFilter
        })
        this._updateUrl(filter)
      } else if (requestedFilter === "ANALYTICS"){
        this.setState({
          integrationsMasterList: this.getIntegrations()
          .filter(item => {
            if (item.category === requestedFilter || item.category === "TAG_MANAGER") {
              return item;
            }
          }),
          filter: requestedFilter
        })
        this._updateUrl(filter)
        
      } else if (requestedFilter === "EMAIL") {
        this.setState({
          integrationsMasterList: this.getIntegrations()
            .filter(item => {
              if (item.category === requestedFilter || item.category === "CADENCE") {
                return item;
              }
            }),
          filter: requestedFilter
        })
        this._updateUrl(filter)

      }else if (requestedFilter==="MESSAGING"){
        this.setState({
          integrationsMasterList: this.getIntegrations()
          .filter(item => {
            if (item.category != "CHAT") {
              return false;
            }

            return true;
          }).map(item => {
            if (item.category === "CHAT") {
              return item;
            }
          }),
          filter: requestedFilter
        })
        this._updateUrl(filter)
      }
      else {
        this.setState({
          integrationsMasterList: this.getIntegrations()
          .filter(item => {
            if (item.category != requestedFilter) {
              return false;
            }

            return true;
          }).map(item => {
            if (item.category === requestedFilter) {
              return item;
            }
          }),
          filter: requestedFilter
        })
        this._updateUrl(filter)

      }
  }

  render(){
    const localizedFilters = this.localizedIntegrations.filters;
    return (
      <div className={styles.content}>
        <div className={styles.titleRow}>
        <div className={cx(styles.title, !this.props.showSettingsMenu && styles.innerPageTitle)}>
          { this.localizedIntegrations.title }
        </div>
        </div>
        <div className={styles.filter}>
          <span className={styles.filterTitle}>{ localizedFilters.title }:</span>
          <button className={cx(styles.filterButton, { [styles.filterButtonActive]: this.state.filter === 'ALL'})} onClick={this._handleFilterClicked.bind(this, 'all')}>{ localizedFilters.all }</button>
          <button className={cx(styles.filterButton, { [styles.filterButtonActive]: this.state.filter === 'EMAIL' })} onClick={this._handleFilterClicked.bind(this, 'email')}>{ localizedFilters.eamil }</button>
          <button className={cx(styles.filterButton, { [styles.filterButtonActive]: this.state.filter === 'CRM' })} onClick={this._handleFilterClicked.bind(this, 'crm')}>{ localizedFilters.CRM }</button>
          <button className={cx(styles.filterButton, { [styles.filterButtonActive]: this.state.filter === 'MESSAGING' })} onClick={this._handleFilterClicked.bind(this, 'messaging')}>{ localizedFilters.messaging }</button>
          <button className={cx(styles.filterButton, { [styles.filterButtonActive]: this.state.filter === 'MARKETING_AUTOMATION' })} onClick={this._handleFilterClicked.bind(this, 'marketing_automation')}>{ localizedFilters.marketing_automation }</button>
          <button className={cx(styles.filterButton, { [styles.filterButtonActive]: this.state.filter === 'ANALYTICS' })} onClick={this._handleFilterClicked.bind(this, 'analytics')}>{ localizedFilters.analytics }</button>
          <button className={cx(styles.filterButton, { [styles.filterButtonActive]: this.state.filter === 'NOTIFICATIONS' })} onClick={this._handleFilterClicked.bind(this, 'notifications')}>{ localizedFilters.notifications }</button>
          <button className={cx(styles.filterButton, { [styles.filterButtonActive]: this.state.filter === 'SOCIAL' })} onClick={this._handleFilterClicked.bind(this, 'social')}>{ localizedFilters.social }</button>
        </div>
        <div className={styles.layout}>
          {this.renderIntegrations()}
        </div>

        <SlidePaneView width="30vw" show={ this.state.showIntegrationConfirmView }>
          <IntegrationConfirmView activatedIntegration={this.state.activatedIntegration}
          clickedIntegration={this.state.clickedIntegration}
           onCancel={
            ()=>{
              this.setState({
                showIntegrationConfirmView: false
              })
            }
          }/>
        </SlidePaneView>
      </div>
    );
  }

  renderIntegrations(){
    let items = this.state.integrationsMasterList
    .filter(integration => {
      if(integration.type === "linkedin" && !this.props.isEmployerAdvocacyEnabled){
        return false;
      }
      let integrationObject = this.getIntegrationForType(integration.type);
      let activated = integrationObject != null;
      let integrationsV2 = this.getIntegrationsV2().includes(integration.type);
      if(integration.type === "cleverstory" && this.props.isCleverstoryIntegrated){
        return true;
      }
      if(!this.props.user.admin){
        if(integrationsV2 && !activated){
          return false;
        }
        return !integration.adminOnly;
      }
      return true;
    })
    .map((integration)=>{

      let integrationObject = this.getIntegrationForType(integration.type);
      let activated = integrationObject != null;
      let state = _.get(integrationObject,"state.code", "ok");
      if(integration.type === "cleverstory" && (this.props.isCleverstoryIntegrated && _.size(this.props.activatedWorkspaces) > 0)){
        activated = true;
      }

      return (
        <CardView key={integration.type} className={cx(styles.integration, {[styles.activated]: activated})}>
          <div onClick = { () => this.handleCardClick(integration, activated) }>
            {state === "auth_error" &&
            <div className={styles.errorMessage}>
              <span className='fa fa-exclamation-triangle'></span>
            </div>}
            <Image src={integration.icon} />
            <h4 className={styles.name}>{integration.name}</h4>
            <p className={styles.description}>{integration.description}</p>
            {activated && 
              <button className={styles.button}>{ this.localizedIntegrations.actions.activated }</button>
            }

            {!activated && 
              <button className={styles.button}>{ this.localizedIntegrations.actions.activate }</button>
            }
          </div>  
        
        </CardView>
      );
    });

    return items;
  }


  getIntegrationForCategory(category){
    try{
      let integration = this.props.activatedIntegrations.filter(item => {
        return item != null
      })
      .find((item) => {
          return item.category.name == category
      })

      return integration;
    }catch(e){}

    return null;
  }

  getIntegrationForType(type){
    try{
      let integration = this.props.integrations.activated.items.filter(item => {
        return item != null
      }).find((item)=>{
          return item.type == type
      })

      return integration;
    }catch(e){}

    return null;
  }

}

export default IntegrationsView;